import { render, staticRenderFns } from "./NotifNotes.vue?vue&type=template&id=b43abcae&scoped=true&"
import script from "./NotifNotes.vue?vue&type=script&lang=js&"
export * from "./NotifNotes.vue?vue&type=script&lang=js&"
import style0 from "./NotifNotes.vue?vue&type=style&index=0&id=b43abcae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43abcae",
  null
  
)

export default component.exports